module.exports = __webpack_public_path__ + "img/1.379a8550.png";